"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var getSize_1 = __importDefault(require("../utils/getSize"));

var getWeight = function getWeight(theme, weight) {
  switch (weight) {
    case 'light':
      return theme.weight.light;

    case 'bold':
      return theme.weight.bold;

    case 'bolder':
      return theme.weight.black;

    default:
      return theme.weight.normal;
  }
};

exports.TextStyle = styled_components_1.default.span(function (_a) {
  var theme = _a.theme,
      align = _a.align,
      size = _a.size,
      weight = _a.weight,
      isDirty = _a.isDirty;
  return {
    color: isDirty ? theme.color.dirty : theme.color.default,
    fontFamily: theme.fontText,
    fontSize: getSize_1.default(theme, size),
    fontWeight: getWeight(theme, weight),
    lineHeight: theme.lineHeight.medium,
    margin: theme.component.margin + " 0px",
    textAlign: align
  };
});
exports.TextStyle.defaultProps = {
  as: 'span',
  size: 'medium'
};
/**
 * Text style.
 *
 * @version 1.0.1
 * @component
 */

exports.default = exports.TextStyle;